<template>
<div id="politicas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>

        <v-layout align-center justify-center>
            <v-flex xs12 s12 m12 l12>
                <base-material-card color="primary" icon="library_books" title="Políticas de Privacidad" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-card-title>
                            <span class="headline" ></span>
                        </v-card-title>                        
                            <v-container grid-list-md text-xs-center >
                                <v-card>
                                    <v-container grid-list-md text-xs-center>
                                        <v-layout row wrap>
                                            <div class="politics" v-html="politica_privacidad" />                                            
                                        </v-layout>                                                                                
                                    </v-container>
                                </v-card>                                                               
                            </v-container>                        
                    </v-card-text>                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    components: {},
    data: () => ({
        fab: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Políticas de Privacidad",
                disabled: true,
                to: ""
            }
        ],                
        loading: false,
        update: false,
        politica_privacidad:"",                
        URL: ""
    }),

    methods: {       
        cargarPoliticas: function() {
            axios
                .get(this.URL + "get_politica_privacidad/")
                .then(res => {
                    if (typeof res.data != undefined && res.data !="") {
                        this.politica_privacidad = res.data;
                    } else {
                        this.politica_privacidad = "No se han ingresado las políticas de privacidad.";  
                    }                    
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener las políticas del sistema.",
                        footer: ""
                    });
                    console.log(err);                                        
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },
                            
    }, //methods
    created: function () {
        this.URL = this.$hostname + "configuracion/politicas/";           
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargarPoliticas();        
    }
};
</script>

<style>
.politics {
    margin-left: 20px;
    height: auto;
    width: auto;
    font-family: Arial, sans-serif;    
}
</style>
